// extracted by mini-css-extract-plugin
module.exports = {"frame":"Services_frame__ZlxsC","arrow":"Services_arrow__Gm3Et","arrowLeft":"Services_arrowLeft__RCcRn","scroller":"Services_scroller__PxTKl"};